import { createAction } from '@reduxjs/toolkit';
import type { QuotaCleanerGroup } from 'reactApp/modules/userQuotaCleaner/userQuotaCleaner.types';
import type { UserQuotaCleanerGroup, UserQuotaCleanerListParams, UserQuotaGroupId, UserQuotaGroupType } from 'reactApp/types/QuotaCleaner';
// <type> - входные данные функции получения
export const loadUserQuotaCleanerList = createAction('userQuotaCleaner/loadList');
export const loadUserQuotaCleanerStart = createAction('userQuotaCleaner/loadListStart');
export const loadUserQuotaCleanerListSuccess = createAction<UserQuotaCleanerGroup[]>('userQuotaCleaner/loadListSuccess');
export const loadUserQuotaCleanerListError = createAction('userQuotaCleaner/loadListError');

export const updateUserQuotaCleanerList = createAction('userQuotaCleaner/updateList');

export const prepareUserQuotaCleanerParams =
    createAction<Partial<Record<UserQuotaGroupId, UserQuotaCleanerListParams>>>('userQuotaCleaner/prepareParams');

export const loadUserQuotaGroup =
    createAction<{ groupId: UserQuotaGroupId; offset?: number; isGroupReset?: boolean; onSuccess?: () => void }>(
        'userQuotaCleaner/loadGroup'
    );
export const loadUserQuotaGroupMore = createAction<{ offset: number }>('userQuotaCleaner/loadGroupMore');
export const loadUserQuotaGroupSuccess =
    createAction<{ data: UserQuotaCleanerGroup; offset: number; limit: number; maxOffset: number; isGroupReset?: boolean }>(
        'userQuotaCleaner/loadGroupSuccess'
    );
export const loadUserQuotaGroupError = createAction('userQuotaCleaner/loadGroupError');
export const loadUserQuotaGroupFromList = createAction<{ groupId: UserQuotaGroupId; onSuccess?: () => void }>(
    'userQuotaCleaner/loadGroupFromList'
);

export const deleteUserQuotaCleanerItems =
    createAction<{ ids: string[]; groupId: UserQuotaGroupId; groupType: UserQuotaGroupType; onDeleteSuccess: () => void }>(
        'userQuotaCleaner/deleteItems'
    );
export const deleteUserQuotaCleanerItemsSuccess = createAction<{
    count: number;
    groupType: UserQuotaGroupType;
    groupId: UserQuotaGroupId;
    ids: string[];
    isMsgRemove?: boolean;
    onDeleteSuccess?: () => void;
}>('userQuotaCleaner/deleteItemsSuccess');

export const deleteUserQuotaCleanerItemsFromStore = createAction<{ deleteIds: string[] }>('userQuotaCleaner/deleteItemsFromStore');
export const resetUserQuotaCurrentGroup = createAction('userQuotaCleaner/resetCurrentGroup');
export const openUserQuotaItemView = createAction<{ id: string; groupId?: UserQuotaGroupId }>('userQuotaCleaner/openItemView');
export const setMessagesRemove = createAction<{ value: boolean }>('userQuotaCleaner/setMessagesRemove');
export const deleteLettersFromQuota =
    createAction<{ ids: string[]; groupId: UserQuotaGroupId; groupType: UserQuotaGroupType; onDeleteSuccess: () => void }>(
        'userQuotaCleaner/deleteLetters'
    );

export const reloadGroupAfterDelete = createAction<{ ids: string[]; groupId: UserQuotaGroupId; isGroupReset?: boolean }>(
    'userQuotaCleaner/reloadGroupAfterDelete'
);
export const setNeedsGroupReload = createAction<{ value: boolean }>('userQuotaCleaner/setNeedsGroupReload');
export const setCurrentGroup = createAction<{ value: QuotaCleanerGroup | null }>('userQuotaCleaner/setCurrentGroup');
export const setIsItemsDeleteProcess = createAction<{ value: boolean }>('userQuotaCleaner/setIsItemsDeleteProcess');
export const setIsItemsDeleteError = createAction<{ value: boolean }>('userQuotaCleaner/setIsItemsDeleteError');
